/*eslint max-lines-per-function: ["error", 120]*/
import React, { useCallback, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';

import {
  GridCountFunction,
  GridGetterFunction,
} from '../../../common/components/Grid/GridDataTypes';
import { useSpdCore } from '../../../common/hooks/useSpdCore';
import { SalesInvoiceSearch } from '../SalesInvoice/SalesInvoicesSearch';

interface AddLinkModalProps {
  show: boolean;
  onHide: () => void;
  onConfirm: (invoiceIds: string[]) => void;
  paymentId?: string;
  paymentSender?: string | null;
  paymentTitle?: string | null;
}

export const AddLinkModal: React.FC<AddLinkModalProps> = ({
  show,
  onHide,
  onConfirm,
  paymentId,
  paymentSender,
  paymentTitle,
}) => {
  const [selectedIds, setSelectedIds] = useState<string[]>([]);
  const spd = useSpdCore();

  const handleHide = () => {
    setSelectedIds([]);
    onHide();
  };

  const handleRowClick = (invoiceId: string) => {
    setSelectedIds(prev =>
      prev.includes(invoiceId)
        ? prev.filter(id => id !== invoiceId)
        : [...prev, invoiceId],
    );
  };

  const handleConfirm = () => {
    onConfirm(selectedIds);
    setSelectedIds([]);
  };

  const getData: GridGetterFunction = useCallback(
    (
      pageSize,
      pageNumber,
      orderBy,
      orderDirection,
      filterText,
      filterColumns,
    ) =>
      spd.salesInvoices.getAllByPortion(
        pageSize,
        pageNumber,
        orderBy,
        orderDirection,
        filterText,
        filterColumns,
        undefined,
        undefined,
        true,
        undefined,
        true,
        paymentId,
      ),
    [spd.salesInvoices, paymentId],
  );

  const getCount: GridCountFunction = useCallback(
    (filterText, filterColumns) =>
      spd.salesInvoices.getAllCount(
        filterText,
        filterColumns,
        undefined,
        undefined,
        true,
        undefined,
        true,
        paymentId,
      ),
    [spd.salesInvoices, paymentId],
  );

  return (
    <Modal show={show} onHide={handleHide} dialogClassName="modal-90w">
      <Modal.Header closeButton>
        <Modal.Title>
          <div>Wybierz faktury do powiązania z wpłatą</div>
          {(paymentSender || paymentTitle) && (
            <div className="fs-6 fw-normal text-muted mt-1">
              {paymentSender && (
                <div>
                  <span className="fw-bold">Nadawca</span>: {paymentSender}
                </div>
              )}
              {paymentTitle && (
                <div>
                  <span className="fw-bold">Tytuł</span>: {paymentTitle}
                </div>
              )}
            </div>
          )}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <SalesInvoiceSearch
          getData={getData}
          getCount={getCount}
          onRowClick={handleRowClick}
          showFilter={true}
          withFilterInColumns={true}
          withoutCorrectionButton={true}
          enableMultiSelect={true}
          selectedKeys={selectedIds}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="primary"
          onClick={handleConfirm}
          disabled={selectedIds.length === 0}
        >
          Dodaj zaznaczone ({selectedIds.length})
        </Button>
        <Button variant="secondary" onClick={handleHide}>
          Anuluj
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
